// Service Worker Registration
import { logError } from './services/logtail';

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .then((registration) => {
          
          // Check if there's an update available
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // New service worker installed
                }
              });
            }
          });
        })
        .catch((registrationError) => {
          logError('SW registration failed', { error: registrationError instanceof Error ? registrationError.message : String(registrationError) });
        });
    });
  } else {
    // Service Worker not supported
  }
}

// Check if app is installed
export function isAppInstalled(): boolean {
  return window.matchMedia('(display-mode: standalone)').matches ||
         (window.navigator as any).standalone === true;
}

// Listen for beforeinstallprompt event
export function setupInstallPrompt(callback: (event: any) => void) {
  window.addEventListener('beforeinstallprompt', (event) => {
    // Prevent the mini-infobar from appearing on mobile
    event.preventDefault();
    // Store the event so it can be triggered later
    callback(event);
  });
}

// Check if PWA is installable
export function isPWAInstallable(): boolean {
  return 'serviceWorker' in navigator && 
         'PushManager' in window &&
         window.matchMedia('(display-mode: standalone)').matches === false;
} 